import {getPermissionsSecondary} from './Permissions'
import { Form, Grid, Dropdown, Segment, Button, Modal, Icon} from 'semantic-ui-react'
import { getClinicas } from '../../api/Orion/clinica'
import {getProvincias} from '../../api/Common/provincia'
import {getProveedores} from '../../api/Lizen/proveedor'
import { getAseguradoras } from '../../api/Orion/aseguradora';
import { getConvenio } from '../../api/Lizen/aseguradora';
import {useFormik} from 'formik'
import Moment from 'moment';
import * as Yup from 'yup'
import { useState, useEffect, useCallback } from 'react'
import { getLocalidades } from '../../api/Common/localidad'
import { LIMITS } from '../../utils/constantes'
import { transformClinicasToOptions, transformAseguradorasToOptions, transformProvinciasToOptions, transformLocalidadesToOptions } from '../../utils/dataTransformers'

export function FiltersOrionService({show,onClose,onConfirm,onClear,auth,type}){
    const estados = [
		{ key: 0, text: 'Todos', value: 0},
		{ key: 1, text: 'En tratamiento', value: 1 },
		{ key: 2, text: 'Abandono tratamiento', value: 2 },
		{ key: 3, text: 'Dado de alta', value: 3 },
		{ key: 4, text: 'No autorizado', value:4},
		{ key: 5, text: 'Pendiente de revisión', value: 5},
		{ key: 6, text: 'con OS/Particular', value: 6},
		{ key: 7, text: 'No se presentó', value: 7},
		{ key: 8, text: 'Agotó suma asegurada', value: 8},
		{ key: 9, text: 'Rechazado', value: 9 },
	]
    const [clinicas, setClinicas] = useState([])
    const [aseguradoras, setAseguradoras] = useState([])
    const formik = useFormik({
		initialValues:initialValues(auth),
		validationSchema:Yup.object(validationSchema()),
		enableReinitialize: true
	})

    const proccess_clinica = useCallback((data)=>{
        setClinicas(transformClinicasToOptions(data))
	}, [])
    
    const proccess_aseguradora = useCallback((data)=>{
        setAseguradoras(transformAseguradorasToOptions(data))
	}, [])
	
	const fetchClinicas = useCallback(async () =>{
		try {
			const clinicas = await getClinicas()
			if(clinicas) {
				proccess_clinica(clinicas)
			}
		} catch (error) {
			console.error("Error al obtener clínicas:", error);
		}
	}, [proccess_clinica])
    
    const fetchAseguradoras = useCallback(async () =>{
        try {
			const aseguradoras = await getAseguradoras()
			if(aseguradoras && aseguradoras.results) {
				proccess_aseguradora(aseguradoras.results)
			}
		} catch (error) {
			console.error("Error al obtener aseguradoras:", error);
		}
    }, [proccess_aseguradora])

    useEffect(()=>{
		//scroll.scrollToTop();
        fetchClinicas(); 
        fetchAseguradoras();
        
    },[fetchClinicas, fetchAseguradoras])
    const onClearFilters = ()=>{
       
        formik.setFieldValue("estado",[])
        formik.setFieldValue("clinica",[])
        formik.setFieldValue("aseguradora",[])
        formik.setFieldValue("created_at_from",null)
        formik.setFieldValue("created_at_to",null)
        onClear()
    }

    return(
        <Modal className='modal-basic' open={show} size={"large"}>
            <Modal.Header>
                <div  style={{textAlign: 'center'}}><Icon name='filter' className='color_search' inverted circular size="large" /> <p >Filtros</p></div>
            </Modal.Header>
             <Modal.Content>
               
                <Form   style={{display:'grid'}}>
                <Grid as={Segment}>
                        {getPermissionsSecondary("created_at",auth,'filters',type) &&  <Grid.Row>
                                
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Fecha desde</h5> 
                                        <Form.Input
                                            type="date"
                                            name="created_at_from"
                                            
                                            value={formik.values.created_at_from}
                                            onChange={(_,data)=>formik.setFieldValue("created_at_from",data.value)}
                                        />   
                                    </Grid.Column>	
                               
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                 <h5>Fecha hasta</h5> 
                                    <Form.Input
                                        type="date"
                                        name="created_at_to"
                                         
                                        value={formik.values.created_at_to}
                                        onChange={(_,data)=>formik.setFieldValue("created_at_to",data.value)}
                                    />   
                                </Grid.Column>	
                                <Grid.Column  mobile={16} >
                                </Grid.Column>
                            

                            </Grid.Row>
                        }
                        {getPermissionsSecondary("estado_descripcion",auth,'filters',type) &&  <Grid.Row>
                        
                                <Grid.Column computer={16} mobile={16} tablet={16}> 
                                    <h5>Estado</h5>
                                    <Dropdown
                                        upward 
                                        
                                        search
                                        fluid
                                        clearable
                                        options={estados}    
                                        value={formik.values.estado}  	
                                        selection 
                                        
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("estado",data.value)}	
                                    />
                                </Grid.Column>	

                            </Grid.Row>
                        }
                        {getPermissionsSecondary("aseguradora_long_name",auth,'filters',type) &&  <Grid.Row>
                            <Grid.Column computer={16} mobile={16} tablet={16}> 
                                    <h5>Convenio</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={aseguradoras}    
                                        value={formik.values.aseguradora}  	
                                        selection 
                                        
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("aseguradora",data.value)}	
                                    />
                                </Grid.Column>	
                               
                                </Grid.Row>
                        }
                        {getPermissionsSecondary("clinica_nombre",auth,'filters',type) &&  <Grid.Row>
                            <Grid.Column computer={16} mobile={16} tablet={16}> 
                                    <h5>Clínica</h5>
                                    <Dropdown
                                        search
                                        upward
                                        clearable
                                        options={clinicas}    
                                        value={formik.values.clinica}  	
                                        selection 
                                        fluid
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("clinica",data.value)}	
                                    />
                                </Grid.Column>	
                             
                            </Grid.Row>
                        }

            
                 </Grid>       
                    </Form>
             </Modal.Content>
         <Modal.Actions>
            <Button  color='red' inverted  onClick={onClose} >
            <Icon name='remove' /> {"Cancelar"}
            </Button>
            <Button color='blue' inverted  onClick={() =>onClearFilters()} >
            <Icon name='trash alternate' /> {"Limpiar filtros"}
            </Button>
            <Button color='green' inverted  onClick={() =>onConfirm(formik.values)} >
            <Icon name='checkmark' /> {"Aplicar"}
            </Button>
           
        </Modal.Actions> 
   </Modal>

        
    )

}
function initialValues(auth){
    let filtro = {
        estado: [],
        clinica: [],
        aseguradora:[],
        created_at_from:null,
        created_at_to:null,
        proveedor:[],
        convenio:[],
        provincia:[],
        localidad:[],
    }

    // let filtrosExistentes = localStorage.getItem('lizen_servicios_filters') 
    let filtrosExistentes 
    let url = window.location.href

    if(url.includes('servicios_lizen')){
        filtrosExistentes =  sessionStorage.getItem('lizen_servicios_filters')
    } else if(url.includes('servicios_orion')) {
        filtrosExistentes =  sessionStorage.getItem('orion_servicios_filters')
    } else {
        filtrosExistentes = sessionStorage.getItem('orion_beneficiarios_filters')
    }

    if(filtrosExistentes){
        filtrosExistentes = filtrosExistentes.split('&')

        let estado = filtrosExistentes.find(x=>x.includes('estado'))
        let estados = estado ? estado.split('=')[1].split(',') : []
        if(isNaN(parseInt(estados[0]))) {
            filtro.estado = estado ? estado.split('=')[1].split(',') : []
        } else {
            filtro.estado = estados.map(x=>parseInt(x))
        }

        let proveedor = filtrosExistentes.find(x=>x.includes('proveedor'))
        let proveedores = proveedor ? proveedor.split('=')[1].split(',') : []
        filtro.proveedor = proveedores.map(x=>parseInt(x))

        let convenio = filtrosExistentes.find(x=>x.includes('convenio'))
        let convenios = convenio ? convenio.split('=')[1].split(',') : []
        filtro.convenio = convenios.map(x=>parseInt(x))

        let created_at_from = filtrosExistentes.find(x=>x.includes('fecha_inicio'))
        filtro.created_at_from = created_at_from ? Moment(created_at_from.split('=')[1]).startOf('day').format('YYYY-MM-DD HH:mm:ss').split(' ')[0] : null
        
        let created_at_to = filtrosExistentes.find(x=>x.includes('fecha_fin'))
        filtro.created_at_to = created_at_to ? Moment(created_at_to.split('=')[1]).startOf('day').format('YYYY-MM-DD HH:mm:ss').split(' ')[0] : null

        let provincia = filtrosExistentes.find(x=>x.includes('provincia'))
        let provincias = provincia ? provincia.split('=')[1].split(',') : []
        filtro.provincia = provincias.map(x=>parseInt(x))

        let localidad = filtrosExistentes.find(x=>x.includes('localidad'))
        let localidades = localidad ? localidad.split('=')[1].split(',') : []
        filtro.localidad = localidades.map(x=>parseInt(x))

        let aseguradora = filtrosExistentes.find(x=>x.includes('aseguradora'))
        let aseguradoras = aseguradora ? aseguradora.split('=')[1].split(',') : []
        filtro.aseguradora = aseguradoras.map(x=>parseInt(x))

        let servicio_clinica = filtrosExistentes.find(x=>x.includes('servicio_clinica'))
        let clinicas = servicio_clinica ? servicio_clinica.split('=')[1].split(',') : []
        filtro.clinica = clinicas.map(x=>parseInt(x))

    }

	return filtro
}

function validationSchema (){
    return {}
}

export function FiltersLizenService({show,onClose,onConfirm,onClear,auth,type}){

    const estados = [
		{ key: 0, text: 'Todos', value: 0 },
		{ key: 1, text: 'Activo', value: 'Activo' },
		{ key: 2, text: 'Legajo', value: 'Legajo' },
		{ key: 3, text: 'Facturado', value: 'Facturado' },
		{ key: 4, text: 'Abonado', value: 'Abonado' },
        { key: 5, text: 'Particular', value: 'Particular' },
        { key: 5, text: 'Rechazado', value: 'Rechazado' },
	]
    const [provincias, setProvincias] = useState([])
    const [localidades, setLocalidades] = useState([])
    const [proveedores, setProveedores] = useState([])
    const [convenios, setConvenios] = useState([])
    
    const formik = useFormik({
		initialValues:initialValues(auth),
		validationSchema:Yup.object(validationSchema()),
		enableReinitialize: true
	})

    const proccess_provincias = useCallback((data)=>{
        setProvincias(transformProvinciasToOptions(data))
    }, [])

    const process_localidades = useCallback((data)=>{
        setLocalidades(transformLocalidadesToOptions(data))
    }, [])

    const proccess_proveedores = useCallback((data)=>{
		let proveedores_process = data.map((x) => {
			return{ key: x.id, text: x.razon_social, value: x.id }
		})
		
        setProveedores(proveedores_process)
	}, [])
    
    const proccess_convenios = useCallback((data)=>{
		let convenios_process = data.map((x) => {
			return{ key: x.id, text: x.nombre, value: x.id }
		})
		
        setConvenios(convenios_process)
	}, [])

	const fetchProvincias = useCallback(async () =>{
		const provincias = await getProvincias()
		.then(data=>{
			proccess_provincias(data.results)
            return data.results
		})
	}, [proccess_provincias])
	
	const fetchLocalidades = useCallback(async () =>{
		try {
			const localidades = await getLocalidades()
			if(localidades && localidades.results) {
				if(formik.values.provincia && formik.values.provincia.length > 0){
					let filterLocaldiades = localidades.results.filter(x=>formik.values.provincia.includes(x.provincia))
					process_localidades(filterLocaldiades)
				} else {
					process_localidades(localidades.results)
				}
			}
		} catch (error) {
			console.error("Error al obtener localidades:", error);
		}
    }, [formik.values.provincia, process_localidades])

    const fetchProveedores = useCallback(async () =>{
		try {
			const proveedores = await getProveedores(`is_active=1`)
			if(proveedores) {
				proccess_proveedores(proveedores)
			}
		} catch (error) {
			console.error("Error al obtener proveedores:", error);
		}
	}, [proccess_proveedores])
    
    const fetchConvenios = useCallback(async () =>{
		try {
			const convenios = await getConvenio()
			if(convenios && convenios.results) {
				proccess_convenios(convenios.results)
			}
		} catch (error) {
			console.error("Error al obtener convenios:", error);
		}
	}, [proccess_convenios])
   
    useEffect(()=>{
		
        fetchProvincias(); 
        fetchLocalidades(); 
        fetchProveedores(); 
        fetchConvenios(); 
        
    },[fetchProvincias, fetchLocalidades, fetchProveedores, fetchConvenios])
	
    useEffect(()=>{
        fetchLocalidades()
    },[fetchLocalidades])
   
    const onClearFilters = ()=>{
       
        formik.setFieldValue("estado",[])
        formik.setFieldValue("provincia",[])
        formik.setFieldValue("convenio",[])
        formik.setFieldValue("created_at_from",null)
        formik.setFieldValue("created_at_to",null)
        onClear()
    }

    return(
        <Modal className='modal-basic' open={show} size={"large"}>
            <Modal.Header>
                <div  style={{textAlign: 'center'}}><Icon name='filter' className='color_search' inverted circular size="large" /> <p >Filtros</p></div>
            </Modal.Header>
             <Modal.Content>
               
                <Form   style={{display:'grid'}}>
                <Grid as={Segment}>
                        {getPermissionsSecondary("created_at",auth,'filters',type) &&  <Grid.Row>
                                
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Fecha desde</h5> 
                                        <Form.Input
                                            type="date"
                                            name="created_at_from"
                                            
                                            value={formik.values.created_at_from}
                                            onChange={(_,data)=>formik.setFieldValue("created_at_from",data.value)}
                                        />   
                                    </Grid.Column>	
                               
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                 <h5>Fecha hasta</h5> 
                                    <Form.Input
                                        type="date"
                                        name="created_at_to"
                                         
                                        value={formik.values.created_at_to}
                                        onChange={(_,data)=>formik.setFieldValue("created_at_to",data.value)}
                                    />   
                                </Grid.Column>	
                                <Grid.Column  mobile={16} >
                                </Grid.Column>
                            

                            </Grid.Row>
                        }
                        {getPermissionsSecondary("estado",auth,'filters',type) &&  <Grid.Row>
                        
                                <Grid.Column computer={16} mobile={16} tablet={16}> 
                                    <h5>Estado</h5>
                                    <Dropdown
                                        upward 
                                        
                                        search
                                        fluid
                                        clearable
                                        options={estados}    
                                        value={formik.values.estado}  	
                                        selection 
                                        
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("estado",data.value)}	
                                    />
                                </Grid.Column>	

                            </Grid.Row>
                        }
                        {getPermissionsSecondary("servicio_provincia_nombre",auth,'filters',type) &&  
                            <Grid.Row>
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Provincia</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={provincias}    
                                        value={formik.values.provincia}  	
                                        selection 
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("provincia",data.value)}	
                                    />
                                </Grid.Column>	
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Localidad</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={localidades}    
                                        value={formik.values.localidad}  	
                                        selection 
                                        multiple
                                        limit={LIMITS.DEFAULT_PAGINATION}
                                        onChange={(_,data)=>formik.setFieldValue("localidad",data.value)}	
                                    />
                                </Grid.Column>	
                            </Grid.Row>
                        }
                        {getPermissionsSecondary("proveedor_cocheria_razon_social",auth,'filters',type) &&  
                            <Grid.Row>
                                <Grid.Column computer={16} mobile={16} tablet={16}> 
                                    <h5>Proveedor</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={proveedores}    
                                        value={formik.values.proveedor}  	
                                        selection 
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("proveedor",data.value)}	
                                    />
                                </Grid.Column>	
                               
                            </Grid.Row>
                        }
                         {getPermissionsSecondary("cliente_convenio_nombre",auth,'filters',type) &&  <Grid.Row>
                            <Grid.Column computer={16} mobile={16} tablet={16}> 
                                    <h5>Convenio</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={convenios}    
                                        value={formik.values.convenio}  	
                                        selection 
                                        
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("convenio",data.value)}	
                                    />
                                </Grid.Column>	
                               
                                </Grid.Row>
                        }
                        
            
                 </Grid>       
                    </Form>
             </Modal.Content>
         <Modal.Actions>
            <Button  color='red' inverted  onClick={onClose} >
            <Icon name='remove' /> {"Cancelar"}
            </Button>
            <Button color='blue' inverted  onClick={() =>onClearFilters()} >
            <Icon name='trash alternate' /> {"Limpiar filtros"}
            </Button>
            <Button color='green' inverted  onClick={() =>onConfirm(formik.values)} >
            <Icon name='checkmark' /> {"Aplicar"}
            </Button>
           
        </Modal.Actions> 
   </Modal>

        
    )

}

export function FiltersOrionBeneficiaro({show,onClose,onConfirm,onClear,auth,type}){
    const [aseguradoras, setAseguradoras] = useState([])
    const formik = useFormik({
        initialValues:initialValues(auth),
        validationSchema:Yup.object(validationSchema()),
        enableReinitialize: true
    })
    const proccess_aseguradora = useCallback((data)=>{
        let aseguradoras_process = data.map((x) => {
            return{ key: x.id, text: x.short_name, value: x.id }
        })

        setAseguradoras(aseguradoras_process)
    }, [])

    const fetchAseguradoras = useCallback(async () =>{
        try {
            const data = await getAseguradoras()
            if(data && data.results) {
                proccess_aseguradora(data.results)
            }
        } catch (error) {
            console.error("Error al obtener aseguradoras:", error);
        }
    }, [proccess_aseguradora])

    useEffect(()=>{
        fetchAseguradoras();

    },[fetchAseguradoras])
    const onClearFilters = ()=>{
        formik.setFieldValue("aseguradora",[])
        onClear()
    }

    return(
        <Modal className='modal-basic' open={show} size={"large"}>
            <Modal.Header>
                <div style={{textAlign: 'center'}}><Icon name='filter' className='color_search' inverted circular size="large" /> <p >Filtros</p></div>
            </Modal.Header>
            <Modal.Content>
                <Form style={{display:'grid'}}>
                    <Grid as={Segment}>
                        {getPermissionsSecondary("aseguradora_long_name",auth,'filters',type) &&  <Grid.Row>
                            <Grid.Column computer={16} mobile={16} tablet={16}>
                                <h5>Convenio</h5>
                                <Dropdown
                                    search
                                    upward
                                    fluid
                                    clearable
                                    options={aseguradoras}
                                    value={formik.values.aseguradora}
                                    selection
                                    multiple
                                    onChange={(_,data)=>formik.setFieldValue("aseguradora",data.value)}
                                />
                            </Grid.Column>

                        </Grid.Row>
                        }
                    </Grid>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button  color='red' inverted  onClick={onClose} >
                    <Icon name='remove' /> {"Cancelar"}
                </Button>
                <Button color='blue' inverted  onClick={() =>onClearFilters()} >
                    <Icon name='trash alternate' /> {"Limpiar filtros"}
                </Button>
                <Button color='green' inverted  onClick={() =>onConfirm(formik.values)} >
                    <Icon name='checkmark' /> {"Aplicar"}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

export function FiltersOrionClinica({show,onClose,onConfirm,onClear,auth,type}){
    const [provincias, setProvincias] = useState([])
    const [localidades, setLocalidades] = useState([])
    
    const opcionesBooleanas = [
        { key: 0, text: 'Todos', value: '' },
        { key: 1, text: 'Sí', value: 'true' },
        { key: 2, text: 'No', value: 'false' },
    ]
    
    const formik = useFormik({
        initialValues:initialValuesClinica(auth),
        validationSchema:Yup.object(validationSchema()),
        enableReinitialize: true
    })

    const proccess_provincias = useCallback((data)=>{
        setProvincias(transformProvinciasToOptions(data))
    }, [])

    const process_localidades = useCallback((data)=>{
        setLocalidades(transformLocalidadesToOptions(data))
    }, [])

	const fetchProvincias = useCallback(async () =>{
		try {
			const provincias = await getProvincias()
			if(provincias && provincias.results) {
				proccess_provincias(provincias.results)
			}
		} catch (error) {
			console.error("Error al obtener provincias:", error);
		}
	}, [proccess_provincias])
	
	const fetchLocalidades = useCallback(async () =>{
		try {
			const localidades = await getLocalidades('')
			if(localidades && localidades.results) {
				if(formik.values.clinica_provincia && formik.values.clinica_provincia.length > 0){
					let filterLocaldiades = localidades.results.filter(x=>formik.values.clinica_provincia.includes(x.provincia))
					process_localidades(filterLocaldiades)
				} else {
					process_localidades(localidades.results)
				}
			}
		} catch (error) {
			console.error("Error al obtener localidades:", error);
		}
    }, [formik.values.clinica_provincia, process_localidades])
   
    useEffect(()=>{
        fetchProvincias(); 
        fetchLocalidades(); 
    },[fetchProvincias, fetchLocalidades])
	
    useEffect(()=>{
        fetchLocalidades()
    },[fetchLocalidades])
   
    const onClearFilters = ()=>{
        formik.setFieldValue("clinica_provincia",[])
        formik.setFieldValue("clinica_localidad",[])
        formik.setFieldValue("clinica_convenio",'')
        formik.setFieldValue("clinica_camara",'')
        formik.setFieldValue("clinica_guardia",'')
        formik.setFieldValue("clinica_renovacion",'')
        onClear()
    }

    return(
        <Modal className='modal-basic' open={show} size={"large"}>
            <Modal.Header>
                <div  style={{textAlign: 'center'}}><Icon name='filter' className='color_search' inverted circular size="large" /> <p >Filtros</p></div>
            </Modal.Header>
             <Modal.Content>
               
                <Form   style={{display:'grid'}}>
                <Grid as={Segment}>
                        {getPermissionsSecondary("clinica_provincia",auth,'filters',type) &&  
                            <Grid.Row>
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Provincia</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={provincias}    
                                        value={formik.values.clinica_provincia}  	
                                        selection 
                                        multiple
                                        onChange={(_,data)=>formik.setFieldValue("clinica_provincia",data.value)}	
                                    />
                                </Grid.Column>	
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Localidad</h5>
                                    <Dropdown
                                        search
                                        upward
                                        fluid
                                        clearable
                                        options={localidades}    
                                        value={formik.values.clinica_localidad}  	
                                        selection 
                                        multiple
                                        limit={LIMITS.DEFAULT_PAGINATION}
                                        onChange={(_,data)=>formik.setFieldValue("clinica_localidad",data.value)}	
                                    />
                                </Grid.Column>	
                            </Grid.Row>
                        } 
                        {getPermissionsSecondary("clinica_convenio",auth,'filters',type) &&  
                            <Grid.Row>
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Con Convenio</h5>
                                    <Dropdown
                                        upward
                                        fluid
                                        clearable
                                        options={opcionesBooleanas}    
                                        value={formik.values.clinica_convenio}  	
                                        selection 
                                        onChange={(_,data)=>formik.setFieldValue("clinica_convenio",data.value)}	
                                    />
                                </Grid.Column>	
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Convenio de Cámara</h5>
                                    <Dropdown
                                        upward
                                        fluid
                                        clearable
                                        options={opcionesBooleanas}    
                                        value={formik.values.clinica_camara}  	
                                        selection 
                                        onChange={(_,data)=>formik.setFieldValue("clinica_camara",data.value)}	
                                    />
                                </Grid.Column>	
                            </Grid.Row>
                        }
                        {getPermissionsSecondary("clinica_guardia",auth,'filters',type) &&  
                            <Grid.Row>
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>Con Guardia</h5>
                                    <Dropdown
                                        upward
                                        fluid
                                        clearable
                                        options={opcionesBooleanas}    
                                        value={formik.values.clinica_guardia}  	
                                        selection 
                                        onChange={(_,data)=>formik.setFieldValue("clinica_guardia",data.value)}	
                                    />
                                </Grid.Column>	
                                <Grid.Column computer={8} mobile={16} tablet={8}> 
                                    <h5>En Renovación</h5>
                                    <Dropdown
                                        upward
                                        fluid
                                        clearable
                                        options={opcionesBooleanas}    
                                        value={formik.values.clinica_renovacion}  	
                                        selection 
                                        onChange={(_,data)=>formik.setFieldValue("clinica_renovacion",data.value)}	
                                    />
                                </Grid.Column>	
                            </Grid.Row>
                        }
                    </Grid>
                </Form>
            </Modal.Content>
        <Modal.Actions>
            <Button  color='red' inverted  onClick={onClose} >
                <Icon name='remove' /> {"Cancelar"}
            </Button>
            <Button color='blue' inverted  onClick={() =>onClearFilters()} >
                <Icon name='trash alternate' /> {"Limpiar filtros"}
            </Button>
            <Button color='green' inverted  onClick={() =>onConfirm(formik.values)} >
                <Icon name='checkmark' /> {"Aplicar"}
            </Button>
        </Modal.Actions> 
   </Modal>

        
    )

}

export function FiltersLizenProveedor({show, onClose, onConfirm, onClear, auth, type}){
    const [provincias, setProvincias] = useState([])
    const [localidades, setLocalidades] = useState([])

    const formik = useFormik({
        initialValues: initialValuesProveedor(auth),
        validationSchema: Yup.object(validationSchema()),
        enableReinitialize: true
    })

    const proccess_provincias = useCallback((data)=>{
        setProvincias(transformProvinciasToOptions(data))
    }, [])

    const process_localidades = useCallback((data)=>{
        setLocalidades(transformLocalidadesToOptions(data))
    }, [])

    const fetchProvincias = useCallback(async () =>{
        try {
            const provincias = await getProvincias()
            if(provincias && provincias.results) {
                proccess_provincias(provincias.results)
            }
        } catch (error) {
            console.error("Error al obtener provincias:", error);
        }
    }, [proccess_provincias])

    const fetchLocalidades = useCallback(async () =>{
        try {
            const localidades = await getLocalidades('')
            if(localidades && localidades.results) {
                if(formik.values.proveedor_provincia && formik.values.proveedor_provincia.length > 0){
                    let filterLocaldiades = localidades.results.filter(x=>formik.values.proveedor_provincia.includes(x.provincia))
                    process_localidades(filterLocaldiades)
                } else {
                    process_localidades(localidades.results)
                }
            }
        } catch (error) {
            console.error("Error al obtener localidades:", error);
        }
    }, [formik.values.proveedor_provincia, process_localidades])

    useEffect(()=>{
        fetchProvincias();
        fetchLocalidades();
    },[fetchProvincias, fetchLocalidades])

    useEffect(()=>{
        fetchLocalidades()
    },[fetchLocalidades])

    const onClearFilters = ()=>{
        formik.setFieldValue("proveedor_provincia", [])
        formik.setFieldValue("proveedor_localidad", [])
        onClear()
    }

    return(
        <Modal className='modal-basic' open={show} size={"large"}>
            <Modal.Header>
                <div style={{textAlign: 'center'}}><Icon name='filter' className='color_search' inverted circular size="large" /> <p>Filtros</p></div>
            </Modal.Header>
            <Modal.Content>
                <Form style={{display:'grid'}}>
                    <Grid as={Segment}>
                        <Grid.Row>
                            <Grid.Column computer={8} mobile={16} tablet={8}>
                                <h5>Provincia</h5>
                                <Dropdown
                                    search
                                    upward
                                    fluid
                                    clearable
                                    options={provincias}
                                    value={formik.values.proveedor_provincia}
                                    selection
                                    multiple
                                    onChange={(_,data)=>formik.setFieldValue("proveedor_provincia", data.value)}
                                />
                            </Grid.Column>
                            <Grid.Column computer={8} mobile={16} tablet={8}>
                                <h5>Localidad</h5>
                                <Dropdown
                                    search
                                    upward
                                    fluid
                                    clearable
                                    options={localidades}
                                    value={formik.values.proveedor_localidad}
                                    selection
                                    multiple
                                    limit={LIMITS.DEFAULT_PAGINATION}
                                    onChange={(_,data)=>formik.setFieldValue("proveedor_localidad", data.value)}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button color='red' inverted onClick={onClose}>
                    <Icon name='remove' /> {"Cancelar"}
                </Button>
                <Button color='blue' inverted onClick={() => onClearFilters()}>
                    <Icon name='trash alternate' /> {"Limpiar filtros"}
                </Button>
                <Button color='green' inverted onClick={() => onConfirm(formik.values)}>
                    <Icon name='checkmark' /> {"Aplicar"}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

function initialValuesProveedor(auth){
    let filtro = {
        proveedor_provincia: [],
        proveedor_localidad: [],
    }

    let filtrosExistentes = sessionStorage.getItem('lizen_proveedores_filters')

    if(filtrosExistentes){
        filtrosExistentes = filtrosExistentes.split('&')

        let provincia = filtrosExistentes.find(x=>x.includes('provincia'))
        let provincias = provincia ? provincia.split('=')[1].split(',') : []
        filtro.proveedor_provincia = provincias.map(x=>parseInt(x)).filter(x=>!isNaN(x))

        let localidad = filtrosExistentes.find(x=>x.includes('localidad'))
        let localidades = localidad ? localidad.split('=')[1].split(',') : []
        filtro.proveedor_localidad = localidades.map(x=>parseInt(x)).filter(x=>!isNaN(x))
    }

    return filtro
}

function initialValuesClinica(auth){
    let filtro = {
        clinica_provincia: [],
        clinica_localidad: [],
        clinica_convenio: '',
        clinica_camara: '',
        clinica_guardia: '',
        clinica_renovacion: '',
    }

    let filtrosExistentes = sessionStorage.getItem('orion_clinicas_filters')

    if(filtrosExistentes){
        filtrosExistentes = filtrosExistentes.split('&')

        let provincia = filtrosExistentes.find(x=>x.includes('clinica_provincia'))
        let provincias = provincia ? provincia.split('=')[1].split(',') : []
        filtro.clinica_provincia = provincias.map(x=>parseInt(x)).filter(x=>!isNaN(x))

        let localidad = filtrosExistentes.find(x=>x.includes('clinica_localidad'))
        let localidades = localidad ? localidad.split('=')[1].split(',') : []
        filtro.clinica_localidad = localidades.map(x=>parseInt(x)).filter(x=>!isNaN(x))

        let convenio = filtrosExistentes.find(x=>x.includes('clinica_convenio'))
        filtro.clinica_convenio = convenio ? convenio.split('=')[1] : ''

        let camara = filtrosExistentes.find(x=>x.includes('clinica_camara'))
        filtro.clinica_camara = camara ? camara.split('=')[1] : ''

        let guardia = filtrosExistentes.find(x=>x.includes('clinica_guardia'))
        filtro.clinica_guardia = guardia ? guardia.split('=')[1] : ''

        let renovacion = filtrosExistentes.find(x=>x.includes('clinica_renovacion'))
        filtro.clinica_renovacion = renovacion ? renovacion.split('=')[1] : ''
    }

	return filtro
}